var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"max-height":"400px","overflow-y":"auto"}},[_c('h5',{staticStyle:{"margin-bottom":"10px"}},[_vm._v("Liste de ses animaux ("+_vm._s(_vm.clientAnimaux.length)+")")]),_vm._l((_vm.clientAnimaux),function(an,index){return _c('animal',{key:index,attrs:{"animal":an}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }